// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0deaed2c] .el-dialog{width:552px}.dialog-body div p[data-v-0deaed2c]{font-size:16px;color:#686868}", ""]);
// Exports
module.exports = exports;
